// extracted by mini-css-extract-plugin
export default {"he":"h_he__PpneS","lef":"h_lef__JnAfW","txt":"h_txt__Qmr8W","back":"h_back__ib8cI"};